<template>
  <v-btn
    :icon="!isMobile()"
    color="error"
    title="Remover produto"
    @click="removerProduto()"
    :block="isMobile()"
    :rounded="isMobile()"
    :small="isMobile()"
    :depressed="isMobile()"
    ><v-icon :left="isMobile()">mdi-delete-outline</v-icon>
    <span v-if="isMobile()">Remover</span>
  </v-btn>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: mapState("pedidos", ["novopedido"]),
  props: {
    produto: Object,
  },
  methods: {
    ...mapActions("pedidos", ["recalcularFrete"]),
    ...mapGetters("pedidos", ["cobrarFrete"]),
    isMobile() {
      return this.$mq == "sm";
    },
    removerProduto() {
      var pos = this.novopedido.produtos.findIndex(
        (p) => p.id == this.produto.id
      );
      if (pos >= 0) {
        this.novopedido.produtos.splice(pos, 1);
        this.recalcularFrete();
      }
    },
  },
};
</script>

<style>
</style>